import { Injectable } from "@angular/core";
import { Observable, map, throwError } from "rxjs";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { CommunityPlayer } from "@app/core/community/domain/model/community-player";
import {
  CommunityPlayersQuery,
  CommunityPlayersPage,
} from "@app/core/community/domain/community-players.repo";
import {
  CommunityPlayerApiResponse,
  CommunityPlayerListApiResponse,
} from "@app/core/shared/domain/api-types-filtered";

function mapPlayer(data: CommunityPlayerApiResponse): CommunityPlayer {
  return new CommunityPlayer(
    data.email,
    data.name ?? "",
    data.surnames ?? "",
    data.img,
    data.level,
    data.competitive_matches ?? 0
  );
}

@Injectable({ providedIn: "root" })
export class CommunityPlayersWS {
  constructor(
    private baseHandler: BaseHandler,
    private tokenRepo: TokenRepo
  ) {}

  getPlayers(query: CommunityPlayersQuery): Observable<CommunityPlayersPage> {
    const token = this.tokenRepo.get();
    if (token == null) {
      return throwError(() => new MissingCredentialsError());
    }

    const urlParams: Record<string, string | number> = {};
    if (query.search) urlParams["search"] = query.search;
    if (query.page && query.page > 1) urlParams["page"] = query.page;
    if (query.pageSize) urlParams["page_size"] = query.pageSize;

    const builder = new HandlerBuilder()
      .setUrl(ApiUrls.GET_COMMUNITY_PLAYERS_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token));
    if (Object.keys(urlParams).length > 0) {
      builder.setUrlParams(urlParams);
    }

    return this.baseHandler.execute(builder.build()).pipe(
      map((response: CommunityPlayerListApiResponse) => ({
        players: response.results.map(mapPlayer),
        total: response.total,
      }))
    );
  }
}
